import { archReqs } from '@/services/Architectural/ArchitecturalSubmission/store'
import { notifyError, notifyMessage } from '@/services/notify'
import $ from 'jquery'

export const methods = {
  async reload() {
    this.loading = true

    console.debug('originalStipulation=' + JSON.stringify(this.originalStipulation))
    console.debug('architecturalSubmission=' + JSON.stringify(this.architecturalSubmission))

    if (this.originalStipulation) {
      this.formData.stipulation = this.originalStipulation.text
    }

    this.loading = false
  },

  open() {
    this.formData = {
      stipulation: ''
    }
    this.isOpen = true
    this.loading = false
  },

  closeModal() {
    this.$emit('update:toggle', (this.toggle = !this.toggle))

    // auto-close modal
    $('#clickclose').click()
  },

  async onFormSubmit() {
    if (
      !this.formData ||
      this.formData === undefined ||
      !this.architecturalSubmission ||
      !this.formData.stipulation
    ) {
      notifyError('There was a problem finalizing this Stipulation.')
      return
    }
    this.loading = true

    try {
      let finalStipulations = []

      if (
        this.architecturalSubmission.stipulations &&
        this.architecturalSubmission.stipulations !== undefined
      ) {
        finalStipulations = this.architecturalSubmission.stipulations
      }

      finalStipulations.push(this.formData.stipulation)

      console.debug('finalStipulations=' + JSON.stringify(finalStipulations))

      await archReqs.dispatch('put', {
        json: {
          hoaID: this.architecturalSubmission.hoaID,
          ownerID: this.architecturalSubmission.ownerID,
          architecturalSubmissionID: this.architecturalSubmission.architecturalSubmissionID,
          arTransactionID: this.architecturalSubmission.arTransactionID,
          submissionDocumentID: this.architecturalSubmission.submissionDocumentID,
          submissionDocumentDescription: this.architecturalSubmission.submissionDocumentDescription,
          architecturalCategoryID: this.architecturalSubmission.architecturalCategoryID,
          description: this.architecturalSubmission.description,
          detailedDescription: this.architecturalSubmission.detailedDescription,
          feeAmount: this.architecturalSubmission.feeAmount,
          wasApproved: this.architecturalSubmission.wasApproved,
          votingCompleteDate: this.architecturalSubmission.votingCompleteDate,
          estimatedCompletionDate: this.architecturalSubmission.estimatedCompletionDate,
          submissionDate: this.architecturalSubmission.submissionDate,
          respondByDate: this.architecturalSubmission.respondByDate,
          toBeCompletedBy: this.architecturalSubmission.toBeCompletedBy,
          contractor: this.architecturalSubmission.contractor,
          cancelDate: this.architecturalSubmission.cancelDate,
          cancelReason: this.architecturalSubmission.cancelReason,
          cancelledByAspNetUserID: this.architecturalSubmission.cancelledByAspNetUserID,
          denialType: this.architecturalSubmission.denialType,
          committeeID: this.architecturalSubmission.committeeID,
          stipulationsJSON: JSON.stringify(finalStipulations),
          denialReasonsJSON: this.architecturalSubmission.denialReasonsJSON
        }
      })

      notifyMessage('This stipulation has been successfully finalized.')
      this.closeModal()
    } catch (e) {
      notifyError('There was a problem finalizing this stipulation.')
    }
  }
}
